import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getMaterialReservations({ commit }, { paginate, query }) {
        commit('GET_MATERIAL_RESERVATIONS_REQUEST')

        return axios
            .get(`/material-reservations/reservations${paginate}${query}`)
            .then(response => {
                commit('GET_MATERIAL_RESERVATIONS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_MATERIAL_RESERVATIONS_FAILURE')
                handleApiError(error, 'Pobranie listy rezerwacji nie powiodło się.')

                return Promise.reject(error)
            })
    },
    setMaterialReservationsFilters({ commit }, filters) {
        commit('SET_MATERIAL_RESERVATIONS_FILTERS', filters)
    },
    clearMaterialReservationsFilters({ commit }) {
        commit('CLEAR_MATERIAL_RESERVATIONS_FILTERS')
    }
}